// extracted by mini-css-extract-plugin
module.exports = {"jenga":"jenga_jenga__Y_EPp","item":"jenga_item__pIW3E","top-left":"jenga_top-left__eb9dC","top-right":"jenga_top-right__Aq_a6","bottom":"jenga_bottom__KU3to"};